export const BOOKING_DATE = 'bookingDate';
export const START_TIME = 'startTime';
export const END_TIME = 'endTime';
